/**
 * What the shelf models need from a study file: sites with their risk colour, the visit
 * schedule and the doses given or missed per visit, and the drug name.
 */
import type { StudyFile } from '@clinspace/shared';
import type { ModelStudyData } from './models.ts';

export function modelData(file: StudyFile): ModelStudyData {
  const siteRag = new Map<string, 'Red' | 'Amber' | 'Green'>();
  for (const s of file.rbm.sites) siteRag.set(s.siteId, s.rag);
  const dosing = new Map<string, { given: number; missed: number }>();
  for (const d of file.dosing) {
    const entry = dosing.get(d.visitCode) ?? { given: 0, missed: 0 };
    if (d.administered) entry.given++;
    entry.missed += d.missedDoses;
    dosing.set(d.visitCode, entry);
  }
  return {
    sites: file.sites,
    siteRag,
    visitSchedule: file.study.visitSchedule,
    dosing,
    drug: file.dosing[0]?.drug ?? file.study.shortTitle,
  };
}
